import React from "react";
import { TouchableOpacity, Text, StyleSheet } from "react-native";

const ButtonComponent = ({ label, onPress, style, textStyle }) => {
  return (
    <TouchableOpacity 
      style={[styles.button, style]} 
      onPress={onPress} 
      testID="button-component"
    >
      <Text style={[styles.text, textStyle]} testID="button-text">
        {label}
      </Text>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  button: {
    width: "100%",
    alignItems: "center",
    borderRadius: 10,
    fontFamily: 'GT-Walsheim' 

  },
  text: {
    fontSize: 16,
    fontWeight: "600",
    fontFamily: 'GT-Walsheim' 

  },
});

export default ButtonComponent;
